<template>
    <main-layout>
        <div class="container">
            <H1 class="pageTitle">{{item.title}}</H1>
          <div class="wideLimitWidth"><button class="button is-yell is-pulled-right is-small" @click="$router.push('/blog')"><i class="fa fa-arrow-left"></i><b>Back</b></button></div>
            <div class="top40 accSettingsForm wideLimitWidth">
                <div>
                    <div class="is-inline-block">
                        <div class="is-size-4 has-text-yell"><b>{{item.description}}</b></div>
                        <div class="top20" v-html="item.content"></div>
                    </div>
                </div>
            </div>
        </div>
    </main-layout>
</template>

<script>
import MainLayout from '../layouts/Main.vue'
import blogs from '../../static/blogs'


export default {
  components: {
    MainLayout,
  }, 
  data: function() {
    return {
       id: this.$route.query.id,
       item: {}
    }
  },
  mounted: function(){
    var self = this;
    this.blogs = blogs
    this.item = blogs.find(e => {
        return e.id == self.$route.params.id
    })
  },
  methods:{
    
  }
}
</script>

<style scoped>

strong {
    color: white !important
}

</style>


// WEBPACK FOOTER //
// src/pages/BlogArticle.vue